module.exports = __webpack_public_path__ + "img/telemed.3431647f.svg";